import React, { useState } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { FileDoc, FilePdf } from "@bw/icons"

const Download = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  grid-template-columns: 34px 1fr;
  grid-column-gap: 20px;
  text-decoration: none;
  border-radius: 48px;
  padding: 10px 30px;
  box-shadow: none;
  background: none;
  color: var(--primary);
  transition: all 0.2s ease-in-out;
  > div:nth-child(1) {
    transition: all 0.5s ease-in-out;
  }

  &:hover {
    background: var(--primary);
    box-shadow: 0px 15px 25px rgba(0, 33, 209, 0.15);
    color: #fff;
    > div:nth-child(1) {
      background: none;
    }
    .active {
      fill: #fff;
    }
  }
`

const Title = styled.div`
  font-size: 14px;
  font-weight: 700;
  align-self: center;
`

const Excerpt = styled.p`
  font-size: 13px;
  line-height: 1.7;
  grid-column: 2 / 3;
  margin: 0;
`

const IconWrapper = styled.div`
  width: 34px;
  height: 34px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: none;
  border-radius: 50%;
  box-shadow: 0px 0px 25px rgba(11, 23, 40, 0.15);
`

function getExtension(filename) {
  return filename.split(".").pop()
}

const File = ({ title, description, href, hover }) => {
  let filename = href
  let extension = getExtension(filename)
  const [isHovering, setIsHovering] = useState(false)

  const handleMouseOver = () => {
    setIsHovering(true)
  }

  const handleMouseOut = () => {
    setIsHovering(false)
  }

  return (
    <Download
      download
      href={href}
      target="_blank"
      onMouseOver={handleMouseOver}
      onMouseOut={handleMouseOut}
    >
      <IconWrapper>
        {extension === "pdf" ? (
          <FilePdf
            fillColor={isHovering === true ? "#fff" : "var(--primary)"}
          />
        ) : (
          <FileDoc
            fillColor={isHovering === true ? "#fff" : "var(--primary)"}
          />
        )}
      </IconWrapper>
      <div>
        <Title>{title}</Title>
        {description && <Excerpt>{description}</Excerpt>}
      </div>
    </Download>
  )
}

File.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  href: PropTypes.string,
  hover: PropTypes.bool,
}

File.defaultProps = {
  hover: false,
}

export { File }
